module.exports = __webpack_public_path__ + "img/f6-2-4.188e04ae.png";